import { ModuleConstants } from '../../common/constant/modules';
import { ModuleRoutesComponentInterface } from '../../common/routes/types';
import { generateImage } from '../../common/utils/generateImage';
import { ComponentsMap } from './components';
import { RouteConstantsInterface, ScreenNamesInterface } from './types';

export enum RouteConstantEnums {
  SALARY_MAPPING,
  PAYOUT_PROCESSING_EDGE,
  PAYOUT_PROCESSING,
  PROCESSED_PAYOUT_VIEW,
  VENDOR_PROCESSED_PAYOUT_VIEW,
  PAYOUT_PROCESSING_VIEW_INTERNAL_VENDOR,
}

export const RouteConstants: RouteConstantsInterface = {
  SALARY_MAPPING: '/payout/salary-mapping',
  PAYOUT_PROCESSING_EDGE: '/payout/edge-payout-processing',
  PAYOUT_PROCESSING: '/payout/payout-processing',
  PROCESSED_PAYOUT_VIEW: '/payout/payout-processing/:categoryId',
  VENDOR_PROCESSED_PAYOUT_VIEW: '/payout/payout-vendor',
  PAYOUT_PROCESSING_VIEW_INTERNAL_VENDOR: '/payout/vendor-payout-processing',
};

export enum ScreenNameEnums {
  PAYOUT,
  SALARY_MAPPING,
  PAYOUT_PROCESSING_EDGE,
  PAYOUT_PROCESSING,
  PROCESSED_PAYOUT_VIEW,
  PROCESSED_PAYOUT_VIEW_VENDOR,
  VENDOR_PROCESSED_PAYOUT_VIEW,
}

export const ScreenNames: ScreenNamesInterface = {
  PAYOUT: 'Payout',
  SALARY_MAPPING: 'Salary Mapping',
  PAYOUT_PROCESSING_EDGE: 'Payout Processing - Internal',
  PAYOUT_PROCESSING: 'Payout Processing - Tenant',
  PROCESSED_PAYOUT_VIEW: 'Payout Processing - Tenant',
  PROCESSED_PAYOUT_VIEW_VENDOR: 'Payout Processing - Vendor',
  VENDOR_PROCESSED_PAYOUT_VIEW: 'Vendor Payout Processing',
};

const getPayoutsAndIncentiveModuleRoutes: ModuleRoutesComponentInterface =
  () => {
    return [
      {
        id: ModuleConstants.PUBLIC_MODULE_ID,
        route: RouteConstants.SALARY_MAPPING,
        title: ScreenNames.PAYOUT,
        icon: generateImage({
          noScale: true,
          name: 'home-05',
          alt: 'Payout',
          className: 'w-4 h-4',
        }),
        component: null,
        children: [
          {
            id: ModuleConstants.SALARY_MAPPING,
            route: RouteConstants.SALARY_MAPPING,
            title: ScreenNames.SALARY_MAPPING,
            component: ComponentsMap.SALARY_MAPPING,
          },
          {
            id: ModuleConstants.PAYOUT_PROCESSING,
            route: RouteConstants.PAYOUT_PROCESSING_EDGE,
            title: ScreenNames.PAYOUT_PROCESSING_EDGE,
            component: ComponentsMap.PAYOUT_PROCESSING_EDGE,
          },
          {
            id: ModuleConstants.PAYOUT_PROCESSING,
            route: RouteConstants.PAYOUT_PROCESSING,
            title: ScreenNames.PAYOUT_PROCESSING,
            component: ComponentsMap.PAYOUT_PROCESSING,
            children: [
              {
                id: ModuleConstants.PUBLIC_MODULE_ID,
                route: RouteConstants.PROCESSED_PAYOUT_VIEW,
                title: ScreenNames.PROCESSED_PAYOUT_VIEW,
                component: ComponentsMap.PROCESSED_PAYOUT_VIEW,
                sidebarVisibility: false,
              },
            ],
          },
          {
            id: ModuleConstants.EDGE_PAYOUT_PROCESSING,
            route: RouteConstants.PAYOUT_PROCESSING_VIEW_INTERNAL_VENDOR,
            title: ScreenNames.PROCESSED_PAYOUT_VIEW_VENDOR,
            component: ComponentsMap.PAYOUT_PROCESSING_VIEW_INTERNAL_VENDOR,
            // children: [
            //   {
            //     id: ModuleConstants.PUBLIC_MODULE_ID,
            //     route: RouteConstants.PROCESSED_PAYOUT_VIEW,
            //     title: ScreenNames.PROCESSED_PAYOUT_VIEW,
            //     component: ComponentsMap.PROCESSED_PAYOUT_VIEW,
            //     sidebarVisibility: false,
            //   },
            // ],
          },
          {
            id: ModuleConstants.VENDOR_PROCESSED_PAYOUT_VIEW,
            route: RouteConstants.VENDOR_PROCESSED_PAYOUT_VIEW,
            title: ScreenNames.VENDOR_PROCESSED_PAYOUT_VIEW,
            component: ComponentsMap.VENDOR_PROCESSED_PAYOUT_VIEW,
          },
        ],
      },
    ];
  };

export default getPayoutsAndIncentiveModuleRoutes;
